export default __webpack_public_path__ + "static/media/ProForm3.528ae2e4.png";